export const startsWithString = (ref, key, value) => {
  const endValue = value.replace(/.$/, (c) => String.fromCharCode(c.charCodeAt(0) + 1))
  return ref.where(key, '>=', value).where(key, '<=', endValue)
}
